package one.healthium.fodmap.presentation.navigation.health_tools

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner

class DefaultHealthToolsComponent(
    componentContext: ComponentContext,
    private val onLogWeightClicked: () -> Unit,
    private val onLogWaterClicked: () -> Unit,
    private val onMealPlanClicked: (String) -> Unit,
) : HealthToolsComponent, ComponentContext by componentContext, ViewModelStoreOwner by componentContext.viewModelStoreOwner() {
    override fun onLogWeightClicked() {
        onLogWeightClicked.invoke()
    }

    override fun onLogWaterClicked() {
        onLogWaterClicked.invoke()
    }

    override fun onMealPlanClicked(mealPlanId: String) {
        onMealPlanClicked.invoke(mealPlanId)
    }
}